import { useMutation } from '@biletiniz/apollo';
import { FORGOT_PASSWORD } from './gql/forgot-password';

export const useForgotPassword = () => {
    const [useForgotPasswordMutation, { error, loading }] = useMutation(
        FORGOT_PASSWORD
    );

    const forgotPassword = forgotPasswordInfo => {
        return useForgotPasswordMutation({
            variables: forgotPasswordInfo,
        });
    };

    const initialValues = {
        email: '',
        phoneNumber: '90 ',
        verifyPhone: true,
    };

    return {
        error: error?.message,
        forgotPassword,
        loading,
        initialValues,
    };
};
